import { useCallback, useMemo } from "react";

import { useInvestorsSelector } from "store";

export const useGetGroupNames = (): ((investorIds: number[]) => string) => {
  const allInvestors = useInvestorsSelector();

  const idToGroup = useMemo(() => {
    const map = new Map<number, string>();
    allInvestors.forEach((inv) => {
      if (inv.group) map.set(inv.id, inv.group);
    });
    return map;
  }, [allInvestors]);

  return useCallback(
    (investorIds: number[]): string => {
      const groups = new Set<string>();
      investorIds.forEach((id) => {
        const group = idToGroup.get(id);
        if (group) groups.add(group);
      });
      return Array.from(groups).join(", ");
    },
    [idToGroup]
  );
};
